const HelpBlocks = () => {
    return(
        <>
        <div className="helpBlock">
            <h2 className="helpBlockH2">See how Violet can help your care delivery team.</h2>
            <div className="blocks">
                <div className="block1">
                    <h3 className="block1H3">I’m the CEO of a health care organization.</h3>
                    <p className="block1P">I want my patients to know my org is committed to delivering inclusive care.</p>
                </div>
                <div className="block2">
                    <h3 className="block2H3">I’m a DEI strategy leader.</h3>
                    <p className="block2P">I want to ensure my provider team is getting the best inclusivity training.</p>
                </div>
                <div className="block3">
                    <h3 className="block3H3">I'm a provider engagement director.</h3>
                    <p className="block3P">I want to engage and retain my providers with more benefits.</p>
                </div>
            </div>
        </div>
        </>
    );
}

export default HelpBlocks;